import { render, staticRenderFns } from "./NormativaDependenciaTwitterComp.vue?vue&type=template&id=09588c1f&scoped=true&"
import script from "./NormativaDependenciaTwitterComp.vue?vue&type=script&lang=js&"
export * from "./NormativaDependenciaTwitterComp.vue?vue&type=script&lang=js&"
import style0 from "./NormativaDependenciaTwitterComp.vue?vue&type=style&index=0&id=09588c1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09588c1f",
  null
  
)

export default component.exports